import { Overlay as MantineOverlay } from '@mantine/core'

export type OverlayOpacity = 10 | 30 | 70 | 90

export type OverlayProps = {
  /** 透過率（デフォルト: 30） */
  opacity?: OverlayOpacity
  /** クリック時のコールバック */
  onClick?: () => void
  className?: string
}

export function Overlay({ opacity = 30, onClick, className }: OverlayProps) {
  return (
    <MantineOverlay
      color="black"
      backgroundOpacity={opacity / 100}
      onClick={onClick}
      fixed
      aria-hidden="true"
      className={className}
    />
  )
}
